/* eslint-disable react/prop-types */
import React from 'react'
import { DidYouKnowSectionProps } from '../types'
import weddingCouple from 'src/assets/images/CollectionsQuizEntry/ResultCalculationPage/wedding-couple.webp'
import styles from '../styles.module.scss'

export const DidYouKnowSection: React.FC<DidYouKnowSectionProps> = ({ designerCount, weddingCount }) => (
  <div className={styles.resultContainer}>
    <div className={styles.resultContent}>
      <h3 className={styles.didYouKnow}>DID YOU KNOW?</h3>
      <h2 className={styles.title}>Endless possibilities</h2>
      <div className={styles.description}>
        <p>
          With {designerCount}⁺ talented designers nationwide and {weddingCount}⁺ weddings under our belt, your dream
          wedding flowers are in expert hands.
        </p>
      </div>
    </div>
    <div className={styles.imageContainer}>
      <img src={weddingCouple} alt="Wedding couple in forest" className={styles.weddingImage} />
    </div>
  </div>
)
